import type { CatalogSubsectionProps } from '@/features/publicsite/types/catalog/CatalogSubsectionProps';
import { publicCatalog } from '@/i18n/dictionaries/publicCatalog';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * A secondary grid under its own heading — the community page has three.
 *
 * `.catalog-subsection__heading` carries no margin of its own: `.site-main h2` resets it to 0,
 * and `.card-grid`/`.empty-state` set no margin-bottom, so a heading right after either sat flush
 * against it with no visible break between two unrelated lists. The `~` rule in publicsite.css
 * only fires from the second such heading on — three CatalogSubsection calls render as siblings
 * under one parent, so the first heading (right under the page's own lead paragraph, which
 * already has its own spacing) is deliberately left alone.
 */
export function CatalogSubsection<T>({ heading, items, renderCard }: CatalogSubsectionProps<T>) {
  const { t } = useTranslation(publicCatalog);
  return (
    <>
      <h2 className="catalog-subsection__heading">{heading}</h2>
      {items && items.length > 0 && <div className="card-grid">{items.map(renderCard)}</div>}
      {items && items.length === 0 && <p className="empty-state">{t('emptyState')}</p>}
    </>
  );
}
